import axios from "axios"

class CartManager {
    constructor() {
        if (document.querySelector(".add-cart") || document.querySelector(".remove-cart")) {
            axios.defaults.headers.common["X-WP-Nonce"] = hawoData.nonce
            this.topCartItems = document.querySelector(".top-cart-items")
            this.submodules = document.querySelector("#submodules")

            this.events()
        }
    }

    events() {
        this.submodules.addEventListener("click", e => this.clickHandler(e))
    }

    clickHandler(e) {
        if (e.target.classList.contains("add-cart")) this.addToCart(e)
        if (e.target.classList.contains("remove-cart")) this.removeFromCart(e)
    }

    findNearestParentTr(el) {
        let thisItem = el
        while (thisItem.tagName != "TR") {
            thisItem = thisItem.parentElement
        }
        return thisItem
    }

    // methods
    async addToCart(e) {
        e.preventDefault()
        try {
            const response = await axios.get(hawoData.root_url + "/wp-json/hawo/v1/cart?add=" + e.target.getAttribute("data-id"))
            const results = response.data

            document.querySelector(".top-cart-number").innerHTML = results.total
            document.querySelector(".top-checkout-price").innerHTML = results.totalPrice + " €"

            if (results.total) {
                if (!results.notNew) {
                    e.target.parentElement.insertAdjacentHTML(
                        "beforeend",
                        `<p class="text-success mb-0 position-absolute">Module added to your cart</p>`
                    )
                    setTimeout(function () {
                        e.target.parentElement.lastChild.remove()
                    }, 1500)
                }

                const cartEmpty = document.querySelector(".cart-empty")
                if (cartEmpty) cartEmpty.remove()
                this.topCartItems.innerHTML = results.items.map(item =>
                    `<div class="top-cart-item" data-id="${item.id}">
                        <div class="top-cart-item-desc pl-0">
                            <div class="top-cart-item-desc-title">
                                <span class="title">${item.title}</span>
                                <span class="subtitle">${item.module}</span>
                                <span class="top-cart-item-price d-block">${item.price} €</span>
                            </div>
                        </div>
                    </div>
                `).join("")
            } else {
                this.topCartItems.innerHTML = '<p class="cart-empty">Your shopping cart is empty.</p>'
            }
            
        } catch (e) {
            console.log(e)
        }
    }

    async removeFromCart(e) {
        e.preventDefault()
        const thisItem = this.findNearestParentTr(e.target)
        const itemID = e.target.parentElement.getAttribute("data-id")

        try {
            const response = await axios.get(hawoData.root_url + "/wp-json/hawo/v1/cart?remove=" + itemID)
            const results = response.data

            document.querySelector(".top-cart-number").innerHTML = results.total
            document.querySelector(".top-checkout-price").innerHTML = results.totalPrice + " €"
            document.querySelector(".cart-total").innerHTML = "<strong>" + results.totalPrice + " €</strong>"

            setTimeout(function () {
                thisItem.classList.add("fade-out")
            }, 20)
            setTimeout(function () {
                thisItem.remove()
                if (results.total) {
                    this.submodules.innerHTML = results.items.map(item => `
                        <tr class="cart_item">
                            <td class="cart-product-remove">
                                <a class="remove-cart" title="Remove this item" data-id="${item.id}"><i class="icon-trash2 remove-cart"></i></a>
                            </td>

                            <td class="cart-product-thumb mb-3 mb-md-0">
                                ${item.vimeoThumbnail ? `<img width="128" height="72" src="${item.vimeoThumbnail}" alt="${item.module}">` : ""}
                            </td>

                            <td class="cart-product-name">
                                <h4 class="mb-0">${item.title}</h4>
                                <span>${item.module}</span>
                            </td>

                            <td class="cart-product-subtotal">
                                <span class="amount">${item.price} €</span>
                            </td>
                        </tr>
                    `).join("")

                    this.submodules.insertAdjacentHTML(
                        "beforeend",
                        `<tr class="cart_item">
                            <td colspan="3" class="text-center text-md-right border-0">
                                <strong>Total</strong>
                            </td>

                            <td class="text-center border-0">
                                <span class="amount color lead cart-total"><strong>${results.totalPrice} €</strong></span>
                            </td>
                        </tr>`
                    )

                    document.querySelector(".top-cart-items").innerHTML = results.items.map(item => `
                        <div class="top-cart-item" data-id="${item.id}">
                            <div class="top-cart-item-desc pl-0">
                                <div class="top-cart-item-desc-title">
                                    <span class="title">${item.title}</span>
                                    <span class="subtitle">${item.module}</span>
                                    <span class="top-cart-item-price d-block">${item.price} €</span>
                                </div>
                            </div>
                        </div>
                    `).join("")
                } else {
                    document.querySelector(".shopping-cart").innerHTML = `
                    <div class="heading-block text-center text-lg-left border-bottom-0 mb-4">
                        <h4 class="mb-3">Your shopping cart is empty.</h4>
                        <p>There are many great courses at hawo Academy, take a look around!</p>
                    </div>
                    <div class="text-center text-lg-left">
                        <a href="${hawoData.root_url}" class="button button-large button-rounded m-0 center">Continue Shopping</a>
                    </div>
                    `
                    document.querySelector(".top-cart-items").innerHTML = '<p class="cart-empty">Your shopping cart is empty.</p>'
                }
            }, 401)
        } catch (e) {
            console.log(e)
        }
    }

}

export default CartManager
